import type { HelpFile } from '../../types/help'
import { JobDetailTestIds } from '../../../testids/JobDetailTestIds'

export const jobDetailHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobDetailTestIds.jobDetailTitle]:
      'Background jobs run scheduled or on-demand system maintenance, data processing, and integration workflows.',
    [JobDetailTestIds.sectionConfiguration]:
      'Cron schedule, log level, and settings that control when and how this job runs.',
    [JobDetailTestIds.sectionTasks]:
      'Ordered list of tasks executed by this job — each task can be a script, an SQL block, or a built-in connector step.',
    [JobDetailTestIds.sectionRecentExecutions]:
      'Latest executions of this job, with status and duration.',
    [JobDetailTestIds.scheduleEditForm]:
      'Edit the cron expression, log level, and enabled flag — changes take effect on the next scheduler tick.',
    [JobDetailTestIds.inputCron]:
      'Cron expression that determines when this job runs automatically — leave empty to disable scheduled runs.',
    [JobDetailTestIds.selectLogLevel]:
      'Verbosity of log output — DEBUG captures everything, ERROR captures only failures.',
    [JobDetailTestIds.switchEnabled]:
      'Toggle whether this job runs on its schedule — disabled jobs can still be triggered manually.',
    [JobDetailTestIds.btnRunNow]:
      'Trigger an immediate execution of this job, independent of the cron schedule.',
    [JobDetailTestIds.btnEditSchedule]: null,
    [JobDetailTestIds.btnEditTasks]: null,
    [JobDetailTestIds.btnDeleteJob]:
      'Permanently delete this job and its execution history — this action cannot be undone.',
    [JobDetailTestIds.btnScheduleSave]: null,
    [JobDetailTestIds.btnScheduleCancel]: null,
    [JobDetailTestIds.btnConfirmRemoveSchedule]:
      'Remove the cron schedule — the job will only run when triggered manually.',
    [JobDetailTestIds.btnCancelRemoveSchedule]: null,
    [JobDetailTestIds.linkViewAllExecutions]:
      'Open the full execution history for this job, including older runs not shown here.',
  },
}
